module.exports = __webpack_public_path__ + "img/fb_icon-w-01.018d31de.svg";